import {getImage} from "../constants/constants";
import React, {useState} from "react";
import {RiChromeFill} from "react-icons/ri";
import FileReaderModal from "./Modal/FileReaderModal";
import neverLandUtils from "../utils/NeverLandUtils";


const Footer = () => {
  const [fileReaderModalOpen, setFileReaderModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');

  const onClickFooterClause = (title) => {
    setFileReaderModalOpen(true);
    setModalTitle(title);
  }

  return (
      <>
        {fileReaderModalOpen && <FileReaderModal setFileReaderModalOpen={setFileReaderModalOpen} modalTitle={modalTitle}/>}

        <footer
            className="bottom-0 w-full bg-gray-900 py-2 px-2 sm:px-5 items-center justify-between flex flex-row text-gray-300 text-xs">
          <div className="flex flex-col w-full divide-y divide-gray-400">
            <div className="w-full flex flex-row justify-between items-center mb-2">
              <div className="w-full sm:w-4/5 flex sm:flex-row flex-col">
                <img src={getImage('textLogo')} alt="textLogo" className="h-7 w-32 sm:mr-4 mb-2"/>

                <div className="w-full flex flex-row">
                <span className="w-1/2 pr-3 sm:pr-0">
                      (주) 세르 (854-87-02798) <br/>
                      대표 : 오지현<br/>
                      주소 : 서울특별시 강남구 테헤란로 77길 11-8, 7층 A122호 (삼성동, 삼성타워)<br/>
                </span>
                  <span className="w-1/2">
                      등급분류번호 : CC-OM-221117-001(2022-11-17)<br/>
                      결정등급 : 청소년이용불가<br/>
                      장르 : 보드게임(베팅성)<br/>
                </span>
                </div>
              </div>

              <div className="flex sm:flex-row flex-col justify-between">
                <img src={getImage('grade_image01')} alt="grade_image" className="w-12 h-16 sm:mr-3 mb-2 sm:mb-0"/>
                <img src={getImage('grade_image02')} alt="grade_image" className="w-12 h-16"/>
              </div>
            </div>

            <div className="w-full flex flex-col">
              <div className="flex flex-wrap justify-around py-2">
                <button onClick={()=> onClickFooterClause('회사소개')}>[회사소개]</button>
                <button onClick={()=> onClickFooterClause('서비스약관')}>[서비스약관]</button>
                <button onClick={()=> onClickFooterClause('개인정보취급방침')}>[개인정보 취급방침]</button>
                <button onClick={()=> onClickFooterClause('청소년보호정책')}>[청소년 보호정책]</button>
                <button onClick={()=> onClickFooterClause('이메일주소 무단수집 거부')}>[이메일 주소 무단수집 거부]</button>
              </div>

              <p className="text-center">Copyright ⓒ bonasports. All Rights Reserved</p>

              <div className="text-center text-white flex flex-row items-center justify-center mt-1">
                <RiChromeFill className="w-5 h-auto mr-1"/>
                <p>BONASPORTS 사이트는 크롬에 최적화되어있습니다.</p>
              </div>
            </div>
          </div>
        </footer>
      </>
  );
}
export default Footer;